import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=0b2f2aca"
import script from "./Card.js?vue&type=script&lang=js&external"
export * from "./Card.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports